import _defineProperty2 from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Map } from 'immutable';
import classNames from 'classnames';
import { menuGetTree } from '../../../redux/actions/Entity/Menu';
import { normalizeLink, isExternalLink } from '../../../helpers/link';

var Menu = /*#__PURE__*/function (_Component) {
  _inherits(Menu, _Component);

  function Menu() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Menu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Menu)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "sortMenu", function (menu) {
      var sortedMenu = menu.sort(function (itemA, itemB) {
        var weightA = parseInt(itemA.getIn(['link', 'weight']));
        var weightB = parseInt(itemB.getIn(['link', 'weight']));
        return weightA - weightB;
      });
      return sortedMenu;
    });

    return _this;
  }

  _createClass(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          menu = _this$props.menu,
          id = _this$props.id,
          dispatch = _this$props.dispatch;

      if (id && !menu) {
        dispatch(menuGetTree(id));
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          currentLanguage = _this$props2.currentLanguage,
          id = _this$props2.id,
          dispatch = _this$props2.dispatch;

      if (prevProps.currentLanguage !== currentLanguage) {
        dispatch(menuGetTree(id));
      }
    }
  }, {
    key: "renderMenuItems",
    value: function renderMenuItems(menu) {
      var menuItemProps = this.props.menuItemProps; // TODO: set menu active state from here instead of navigation

      if (!menu) return null;
      return menu.map(function (item, index) {
        var attrs = item.getIn(['link', 'options', 'attributes'], Map());
        var href = normalizeLink(item.getIn(['link', 'url']));
        var title = item.getIn(['link', 'title'], 'Untitled');

        var className = menuItemProps.className,
            menuItemPropsLocal = _objectWithoutProperties(menuItemProps, ["className"]);

        var otherAttrs = _objectSpread({
          className: classNames(className),
          target: attrs.get('target')
        }, menuItemPropsLocal);

        return /*#__PURE__*/React.createElement("li", {
          key: "menu--".concat(item.getIn(['link', 'menu_name']), "--menu-item-").concat(title, ":").concat(href)
        }, isExternalLink(href) ? /*#__PURE__*/React.createElement("a", _extends({
          href: href
        }, otherAttrs), title) : /*#__PURE__*/React.createElement(Link, _extends({
          to: href
        }, otherAttrs), title));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          id = _this$props3.id,
          menu = _this$props3.menu,
          children = _this$props3.children; // @FIXME this check doesn't work, error object is in state

      if (!menu) {
        return null;
      }

      var sortedMenu = this.sortMenu(menu);
      var classes = classNames('Menu', "menu--".concat(id));
      return /*#__PURE__*/React.createElement("div", {
        className: classes
      }, typeof children === 'function' ? children(sortedMenu) : /*#__PURE__*/React.createElement("ul", null, this.renderMenuItems(sortedMenu)));
    }
  }]);

  return Menu;
}(Component);

Menu.propTypes = {
  id: PropTypes.string.isRequired,
  menuItemProps: PropTypes.shape({
    className: PropTypes.string
  })
};
Menu.defaultProps = {
  menuItemProps: {}
};

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    children: ownProps.children,
    menu: state.getIn(['menu', ownProps.id]),
    currentLanguage: state.getIn(['ui', 'language'])
  };
}

export default connect(mapStateToProps)(Menu);